module.exports = __webpack_public_path__ + "img/vn-dejun.64d6244b.png";